// extracted by mini-css-extract-plugin
export default {"uploadProgressBar":"src-signer-app-signature-modal-upload-upload-progress-bar-module__uploadProgressBar--2B8kX"};